import React from 'react';
import TextLink from '@cvent/carina/components/TextLink';
import { useOpenCookieModal } from '@cvent/cookieconsent';
import { useTranslate } from 'nucleus-text';

export default function ManageCookiePreference() {
  const { translate } = useTranslate();
  const openCookieModal = useOpenCookieModal();
  return (
    <TextLink element="button" neutral onClick={() => openCookieModal()}>
      {translate('Manage-Cookie-Preferences')}
    </TextLink>
  );
}
